import { stdObject } from "../data/types/stdObject";

export const processPersonsData = (type: string, list: stdObject[]) =>
  list.map((e: stdObject) => {
    const key = `DOM${type.toUpperCase()}`;
    let parsed: stdObject[] = [];
    try {
      parsed = JSON.parse(e[key]) ?? [];
    } catch {
      parsed = [];
    }
    return { ...e, [key]: parsed.filter((v: stdObject) => v.DOMDIR) };
  });
